if (!customElements.get('up2-intent-roi')) {
  class Up2IntentRoi extends HTMLElement {
    connectedCallback() {
      this.sliders = [...this.querySelectorAll('.up2-intent-roi__slider')];
      this.fields = {
        people: this.querySelector('[name="people"]'),
        cards: this.querySelector('[name="cards"]'),
        unit: this.querySelector('[name="unit"]'),
        reprints: this.querySelector('[name="reprints"]'),
      };
      this.displays = {
        people: this.querySelector('[data-roi-display="people"]'),
        cards: this.querySelector('[data-roi-display="cards"]'),
        unit: this.querySelector('[data-roi-display="unit"]'),
        reprints: this.querySelector('[data-roi-display="reprints"]'),
      };
      this.out = {
        paper: this.querySelector('[data-roi-paper]'),
        nfc: this.querySelector('[data-roi-nfc]'),
        nfcUnit: this.querySelector('[data-roi-nfc-unit]'),
        yearOne: this.querySelector('[data-roi-year-one]'),
        after: this.querySelector('[data-roi-after]'),
        breakRow: this.querySelector('[data-roi-break-row]'),
        break: this.querySelector('[data-roi-break]'),
        note: this.querySelector('[data-roi-note]'),
      };
      this.copy = this.readCopy();
      this.locale = this.dataset.locale || 'de';
      this.money = new Intl.NumberFormat(this.locale, {
        style: 'currency',
        currency: 'EUR',
      });
      this.integer = new Intl.NumberFormat(this.locale, { maximumFractionDigits: 0 });
      this.addEventListener('input', () => this.render());
      this.render();
    }

    readCopy() {
      const node = this.querySelector('[data-roi-copy]');
      try {
        return JSON.parse(node?.textContent || '{}');
      } catch (error) {
        return {};
      }
    }

    number(input) {
      const value = Number.parseFloat(String(input?.value || '').replace(',', '.'));
      return Number.isFinite(value) && value >= 0 ? value : 0;
    }

    paintSlider(input) {
      const min = Number.parseFloat(input.min);
      const max = Number.parseFloat(input.max);
      const value = this.number(input);
      const progress = max === min ? 0 : ((value - min) / (max - min)) * 100;
      input.style.setProperty('--roi-progress', `${Math.min(100, Math.max(0, progress))}%`);
    }

    displayValue(input) {
      const value = this.number(input);
      if (input.dataset.roiFormat === 'money') return this.money.format(value);
      return this.integer.format(value);
    }

    render() {
      const people = this.number(this.fields.people);
      const cards = this.number(this.fields.cards);
      const unit = this.number(this.fields.unit);
      const reprints = this.number(this.fields.reprints);
      const nfcEach = this.number({ value: this.dataset.nfcPrice });
      const paperYear = people * cards * unit * reprints;
      const nfcOnce = people * nfcEach;
      const yearOne = paperYear - nfcOnce;

      this.sliders.forEach((slider) => this.paintSlider(slider));
      Object.entries(this.fields).forEach(([key, input]) => {
        if (this.displays[key]) this.displays[key].textContent = this.displayValue(input);
      });

      this.out.paper.textContent = this.money.format(paperYear);
      this.out.nfc.textContent = this.money.format(nfcOnce);
      if (this.out.nfcUnit) this.out.nfcUnit.textContent = this.money.format(nfcEach);
      this.out.yearOne.textContent = this.money.format(yearOne);
      this.out.after.textContent = this.money.format(paperYear);

      if (yearOne > 0) {
        this.out.note.textContent = this.copy.yearOnePositive || '';
      } else if (yearOne < 0) {
        this.out.note.textContent = this.copy.yearOneNegative || '';
      } else {
        this.out.note.textContent = this.copy.yearOneEven || '';
      }

      if (paperYear > 0 && nfcOnce > 0) {
        const years = nfcOnce / paperYear;
        this.out.breakRow.hidden = false;
        this.out.break.textContent = (this.copy.breakEvenYears || '%years%').replace(
          '%years%',
          years.toLocaleString(this.locale, {
            maximumFractionDigits: 1,
            minimumFractionDigits: 0,
          }),
        );
      } else {
        this.out.breakRow.hidden = true;
        this.out.break.textContent = '';
      }
    }
  }

  customElements.define('up2-intent-roi', Up2IntentRoi);
}
